import { createSelector } from '@reduxjs/toolkit';

import { State } from './types';
import { RootState } from '../root-reducer';

const rootSelector = (state: RootState): State => state.MessagesMasks;

export const statusSelector = createSelector(rootSelector, (state) => state.status);

export const errorSelector = createSelector(rootSelector, (state) => state.error);

export const messagesMasksSelector = createSelector(rootSelector, (state) => state.data);

export const selectedMessageMaskSelector = createSelector(rootSelector, (state) => state.selectedMessageMask);

export const hasInformationsSelector = createSelector(
  selectedMessageMaskSelector,
  (selectedMessageMask) =>
    selectedMessageMask?.hasVolumeDelay ||
    selectedMessageMask?.hasSubstituteStation ||
    selectedMessageMask?.hasDock ||
    selectedMessageMask?.hasPrincipalZoneLongMessage ||
    selectedMessageMask?.hasPrincipalZoneShortMessage ||
    selectedMessageMask?.hasSecondaryZoneLongMessage ||
    selectedMessageMask?.hasSecondaryZoneShortMessage
);

export const situationsByClientTypeStatusSelector = createSelector(
  rootSelector,
  (situationsCategory) => situationsCategory.situationsByClientType.status
);
export const situationsByClientTypeErrorSelector = createSelector(
  rootSelector,
  (situationsCategory) => situationsCategory.situationsByClientType.error
);
export const situationsByClientTypeSelector = createSelector(
  rootSelector,
  (situationsCategory) => situationsCategory.situationsByClientType.data
);

export default {
  statusSelector,
  errorSelector,
  messagesMasksSelector,
  selectedMessageMaskSelector,
  hasInformationsSelector,
  situationsByClientTypeStatusSelector,
  situationsByClientTypeErrorSelector,
  situationsByClientTypeSelector,
};
